import { useState, useEffect, useCallback } from 'react';
import { apiCall } from '../../../../_services/apiCall';
import config from '../../../../config/config.json'
import { getLatestFY } from '../../../DataManagment/Quantative/component/answerHistoryPage/components/utils';

const useScopeSummary = (scopeType = "scope 2") => {
  const [scopeData, setScopeData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const getScopeSummary = useCallback(async () => {
    setLoading(true);
    setError(null);
    const financialYears = JSON.parse(localStorage.getItem("financialYears"))
    const currentfy = getLatestFY(financialYears)
    
    try {
      const { isSuccess, data } = await apiCall(
        `${config.POSTLOGIN_API_URL_COMPANY}quantative-data/scope-summary`,
        {},
        { scope: scopeType, fyid:currentfy?.id },
        "GET"
      );

      if (isSuccess) {
        setScopeData(data);
      } else {
        setError("Failed to fetch scope data");
      }
    } catch (err) {
      console.error("❌ API ERROR:", err);
      setError(err.message || "An unexpected error occurred");
    } finally {
      setLoading(false);
    }
  }, [scopeType]);

  useEffect(() => {
    getScopeSummary();
  }, [getScopeSummary]);

  // Return the data, loading state, error, and a refresh function
  return { scopeData, loading, error, refresh: getScopeSummary };
};

export default useScopeSummary;

